'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');
require('./style-222d2b0f.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('./icon.js');
var span = require('./typography/span.js');
var b16 = require('./typography/b16.js');
var transparent = require('./button/transparent.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  min-height: 170px;\n  background-color: white;\n  border: 2px solid ", ";\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-family: Source Sans Pro, sans-serif;\n  padding: 15px;\n  :hover {\n    cursor: pointer;\n    & > button {\n      color: ", ";\n    }\n  }\n"], ["\n  min-height: 170px;\n  background-color: white;\n  border: 2px solid ", ";\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-family: Source Sans Pro, sans-serif;\n  padding: 15px;\n  :hover {\n    cursor: pointer;\n    & > button {\n      color: ", ";\n    }\n  }\n"]);

var InitialBoxContainer = styled__default.div(_templateObject, settings.COLOR.bgGrey, settings.COLOR.deepBlueHover);

var InitialBox = function InitialBox(_ref) {
  var description = _ref.description,
      buttonIcon = _ref.buttonIcon,
      buttonText = _ref.buttonText,
      onClick = _ref.onClick;
  return React__default.createElement(
    InitialBoxContainer,
    { onClick: onClick },
    React__default.createElement(
      b16.default,
      { align: "center", lineHeight: "22px", margin: "0", color: settings.COLOR.lightGray },
      description
    ),
    React__default.createElement(
      transparent.TransparentButton,
      {
        type: "button",
        margin: "0",
        padding: "0",
        color: settings.COLOR.deepBlue,
        hoverColor: settings.COLOR.deepBlueHover },
      React__default.createElement(icon.Icon, { icon: buttonIcon }),
      React__default.createElement(
        span,
        {
          margin: "0 0 0 5px",
          size: "16px",
          lineHeight: "22px",
          color: "inherit",
          weight: "600" },
        buttonText
      )
    )
  );
};

InitialBox.propTypes = {
  /** description text */
  description: PropTypes$1.string,
  /** Icon of button. You can use in icon system */
  buttonIcon: PropTypes$1.string,
  /** Text of button */
  buttonText: PropTypes$1.string,
  /** Call function when click the initial box */
  onClick: PropTypes$1.func
};
InitialBox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InitialBox",
  "props": {
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "description text"
    },
    "buttonIcon": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Icon of button. You can use in icon system"
    },
    "buttonText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Text of button"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Call function when click the initial box"
    }
  }
};

module.exports = InitialBox;
//# sourceMappingURL=initial-box.js.map
